import { NavLink } from 'react-router-dom';
import { BarChart3, Home, Users, Flag, Music, LogOut, DollarSign, Wallet, Settings, Sparkles, Activity, MapPin } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/lib/utils';

// Reproduções removidas em 2026-07-08 — consolidadas em Conteúdo com
// colunas Plays/Views. /plays redireciona pra /content no App.tsx.
const links = [
  { to: '/',          label: 'Dashboard',    icon: Home,      end: true },
  { to: '/atividade', label: 'Atividade',    icon: Activity },
  { to: '/analytics', label: 'Analytics',    icon: BarChart3 },
  { to: '/users',       label: 'Usuários',    icon: Users },
  { to: '/localizacao', label: 'Localização', icon: MapPin },
  { to: '/content',     label: 'Conteúdo',    icon: Music },
  { to: '/reports',   label: 'Denúncias',    icon: Flag },
  { to: '/monetizacao',   label: 'Monetização',  icon: DollarSign },
  { to: '/pro',           label: 'Amuzze Pro',   icon: Sparkles },
  { to: '/financas',      label: 'Finanças',     icon: Wallet },
  { to: '/configuracoes', label: 'Configurações', icon: Settings },
];

export function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <aside className="flex h-screen w-60 flex-col border-r border-border bg-bg-elevated">
      <div className="border-b border-border p-5">
        <div className="text-xl font-semibold text-brand">amuzze</div>
        <div className="text-xs text-text-muted">painel admin</div>
      </div>

      <nav className="flex-1 space-y-1 p-3">
        {links.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-brand-bg text-brand'
                  : 'text-text-secondary hover:bg-bg-input hover:text-text-primary'
              )
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-border p-3">
        <div className="mb-2 px-3 text-xs text-text-muted">
          {user?.username || '—'}
        </div>
        <button
          onClick={logout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-text-secondary transition-colors hover:bg-bg-input hover:text-text-primary"
        >
          <LogOut size={18} />
          Sair
        </button>
      </div>
    </aside>
  );
}
